import { render, staticRenderFns } from "./previousPositionInfo.vue?vue&type=template&id=d1bf8b08"
import script from "./previousPositionInfo.vue?vue&type=script&lang=js"
export * from "./previousPositionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports